import { Divider, SxProps, Tab, Tabs, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import { CTabProps } from "../../Models/Common";
import { TabPanel } from "../TabPanel/TabPanel";

interface Prop {
  TabProperty: CTabProps[];
  isNavigatePath?: boolean;
  sx?: SxProps<Theme>; // SxProps ile sx prop'unun tipi tanımlanır
}
const CTab = ({ isNavigatePath, TabProperty, sx }: Prop) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hash = location?.hash;
  const pathname = location?.pathname;

  const defaultActiveTab = () => {
    const defaultTabItem = TabProperty.find(
      (item, i) => item.defaultTab == true
    );

    if (defaultTabItem) {
      return defaultTabItem.id;
    } else {
      return TabProperty[0].id;
    }
  };

  const [currentTab, setCurrentTab] = useState<number>(defaultActiveTab);
  const handleChangeTab = (newValue: any) => {
    if (isNavigatePath) {
      TabProperty.map((item, i) => {
        if (newValue == item.id) {
          navigate(pathname + TabProperty[newValue].path!!);
        }
      });
    }

    setCurrentTab(newValue);
  };

  useEffect(() => {
    TabProperty.map((item, i) => {
      if (hash == item.path) {
        setCurrentTab(item.id);
      }
    });
  }, [hash, TabProperty]);

  return (
    <>
      <Tabs
        value={currentTab}
        scrollButtons="auto"
        sx={{
          // CRL-3241: black underline indicator
          "& .MuiTabs-indicator": {
            backgroundColor: "#191B1E",
            height: "2px",
          },
          ...sx,
        }}
        variant="scrollable"
        allowScrollButtonsMobile
        onChange={(e, value) => handleChangeTab(value)}
      >
        {TabProperty.map((tab, index) => (
          <Tab
            key={tab.value}
            id={tab.value}
            value={index}
            label={tab.label}
            sx={{
              p: 0,
              mx: 1,
              fontSize: "16px",
              fontWeight: 500,
              textTransform: "initial",
              color: "#8292A5",
              "&.Mui-selected": {
                color: "#191B1E",
                fontWeight: 700,
              },
            }}
            disableRipple
          />
        ))}
      </Tabs>
      <Divider
        sx={{ margin: "0px 16px", borderColor: "#E2E8F0" }}
        variant="inset"
      />
      <SwipeableViews
        index={currentTab}
        onChangeIndex={handleChangeTab}
        enableMouseEvents
      >
        {TabProperty.map((tab, index) => (
          <TabPanel key={tab.value} value={index} index={currentTab}>
            {currentTab != undefined && tab.component(currentTab)}
          </TabPanel>
        ))}
      </SwipeableViews>
    </>
  );
};

export default CTab;
